import { URLS } from '../../constants';
import apiClient from '../client';

const getUsers = {
    getUsersDetail: () => apiClient.post(URLS.getUsers, {}),
    getAssignTo: () => apiClient.post(URLS.getAssignTo, {}),
};

export default getUsers;
